export default __webpack_public_path__ + "static/media/KPIs.d5bff807.jpg";